// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__18Mjh"};